import axios from 'axios'
import config from '@/config'
import { Message } from 'element-ui'
import store from '@/store'
// create an axios instance
const service = axios.create({
  baseURL: config.ApiRoot,
  timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    if (config.params) {
      config.params.libraryId = store.state.user.library.id
    }
    if (config.data) {
      config.data.libraryId = store.state.user.library.id
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// respone interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      // 50008:非法的token;  50014:Token 过期了;
      if (res.code === 401 || res.code === 402) {
        if (window.authorized) {
          window.authorized = false
            Message.error('未登录!')
            store.dispatch('logOut').then(() => {
              // location.reload() // 为了重新实例化vue-router对象 避免bug
            })
          // })
        }
      }
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  /**
   * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
   * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
   */
  error => {
    if (error.response.status !== 401) {
      const res = error.response.data
      let message = error.message
      if (res.responseStatus && res.responseStatus.message) {
        message = res.responseStatus.message
      }
      Message.error(message)
    }
    return Promise.reject(error)
  }
)

export default service
